import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCoilDetails } from '../../Actions/Configurator.action';
import { googleAnalyticsProductConfigurator } from '../../Services/googleAnalytics';

const PanelCoilFoiling = ({ id }) => {
  const dispatch = useDispatch(),
    articleNumber = useSelector((state) => state.configurator.id),
    configurator = useSelector((state) => state.configurator),
    { rules, selections } = configurator,
    { coilInfo } = rules,
    { foilingOptions } = coilInfo;

  const handleOptionChange = (key, value) => {
    dispatch(setCoilDetails(id, 'foilingCoils', key));

    googleAnalyticsProductConfigurator('foilingCoils', value.toString(), articleNumber);

  };

  const getSelectedFoilingCoil = (key) => {
    const foundFoilingCoils = selections.coilDetails.find((coil) => coil.id === id && coil.foilingCoils === key);
    return !!foundFoilingCoils;
  };

  return (
    <Fragment>
      <div className='accordion-panel__panel_header'></div>
      <div className='accordion-panel__panel_content'>
        <div className='configurator__coil_foiling'>
          <div className='coil_foiling_body coil_foiling_body--no-flex'>
            {foilingOptions && Object.entries(foilingOptions).map(([key, value]) => (
              <div className='select-option' key={'foilingCoil' + key}>
                <label>
                  <input type='radio' name='foiling' value={key} checked={getSelectedFoilingCoil(key)}
                    onChange={(e) => { handleOptionChange(key, value); }} />
                  {value}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PanelCoilFoiling;
